module.exports = __webpack_public_path__ + "img/hortanoticias.1e9e2367.png";